import { Component } from "@angular/core";

import { Router, RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { LucideAngularModule, Bot } from "lucide-angular";
import { ChatbotInteractionService } from './services/chatbot-interaction.service';
import { ChatbotSelectorBaseComponent } from '../../shared/components/chatbot-selector/chatbot-selector-base.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { SearchInputComponent } from '../../shared/components/search-input/search-input.component';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { EmptyStateComponent } from '../../shared/components/empty-state/empty-state.component';
import { ChatbotCardGridComponent } from '../../shared/components/chatbot-card-grid/chatbot-card-grid.component';

@Component({
  selector: "app-chatbot-interaction",
  standalone: true,
  imports: [
    FormsModule,
    RouterModule,
    LucideAngularModule,
    PageHeaderComponent,
    SearchInputComponent,
    LoadingSpinnerComponent,
    EmptyStateComponent,
    ChatbotCardGridComponent
],
  templateUrl: './chatbot-interaction.component.html',
})
export class ChatbotInteractionComponent extends ChatbotSelectorBaseComponent {
  readonly Bot = Bot;

  constructor(
    router: Router,
    chatbotService: ChatbotInteractionService
  ) {
    super(router, chatbotService);
    this.redirectPath = '/chatbot/chats'; // Redirect to chat selection
  }
}
